export const MAX_DISPLAY_ONBOARDING_COUNT = 3;
export const ROUTE_ONBOARDING_CONFIG_KEY = 'distance-calculating.onboardingEnabled';
export const ROUTE_ONBOARDING_STORAGE_KEY = 'distance_calculating_onboarding_counter';

export const MAX_DISPLAY_FUTURE_ONBOARDING_COUNT = 3;
export const FUTURE_MAP_ONBOARDING_CONFIG_KEY = 'future-map.onboardingEnabled';
export const FUTURE_MAP_ONBOARDING_COOKIE_KEY = 'future_map_onboarding_counter';
